import { useTranslation } from 'react-i18next';
import { RightArrow } from '../icons';
import { getTranslation, fetchCorrectTranslation } from '../../utils/translation';

const LandingContact = ({ theme = 'basic' }) => {
  const { t } = useTranslation();

  const isTR2026 = theme === 'tr2026';

  // tr_2026 keys live at root — bypass getTranslation (which prepends teamType),
  // but still resolve the { ch, default } variant object via fetchCorrectTranslation
  const get = (subKey) => {
    if (isTR2026) {
      const raw = t(`tr_2026.contact.${subKey}`, { returnObjects: true });
      return fetchCorrectTranslation(raw);
    }
    return getTranslation(t, `landing.contact.${subKey}`);
  };

  const primary = '#005F61';

  const validImagePathOrFullURL = (value) => {
    if (value) {
      return value.startsWith('http') || value.startsWith('/');
    }
    return false;
  };

  return (
    <div className="my-12 px-12 m-auto w-full max-w-[1000px] font-bold grid grid-cols-1 sm:grid-cols-2 gap-10">
      {validImagePathOrFullURL(get('image')) && (
        <img src={get('image')} alt={get('imageAlt') ?? 'contact'} className="block w-full" />
      )}
      <div className="w-full">
        <div
          className="!leading-[2.5rem] md:!leading-[3rem] text-2xl sm:text-4xl md:text-start w-full pb-2 mb-5 font-extrabold text-cblack-secondary"
          dangerouslySetInnerHTML={{ __html: get('info') }}
        />
        <a
          className="mb-3 flex items-center gap-2 w-full bg-left-bottom bg-no-repeat pb-1"
          style={{
            color: primary,
            backgroundImage: `linear-gradient(${primary} 0 0)`,
            backgroundSize: '20% 2px'
          }}
          href={`mailto:${get('email.value')}`}>
          <span dangerouslySetInnerHTML={{ __html: get('email.value') }} />
          <span style={{ color: primary }}>
            <RightArrow />
          </span>
        </a>

        <a
          className="mb-2 flex items-center gap-2 w-full bg-left-bottom bg-no-repeat pb-1"
          style={{
            color: primary,
            backgroundImage: `linear-gradient(${primary} 0 0)`,
            backgroundSize: '20% 2px'
          }}
          href={`tel:${get('phone.value')}`}>
          <span dangerouslySetInnerHTML={{ __html: get('phone.value') }} />
          <span style={{ color: primary }}>
            <RightArrow />
          </span>
        </a>
      </div>
    </div>
  );
};

export default LandingContact;
